import { XIcon } from 'lucide-react'

import { useCarrierBranding } from './CarrierBrandingProvider'

interface CoBrandedHeaderProps {
  /** Additional CSS classes for the container */
  className?: string
}

/**
 * Displays a co-branded header with both the Thatch logo and carrier logo.
 * Format: "THATCH × CarrierLogo"
 * Shows when the current user is opted into a carrier partnership for the prospect's state.
 *
 * Usage:
 * ```tsx
 * <CarrierBrandingProvider state={prospect.state}>
 *   <CoBrandedHeader />
 * </CarrierBrandingProvider>
 * ```
 */
export function CoBrandedHeader ({ className = '' }: CoBrandedHeaderProps) {
  const branding = useCarrierBranding()

  if (!branding?.hasCarrierBranding) {
    return null
  }

  const { carrierPartnership } = branding

  if (!carrierPartnership?.logo_url) {
    return null
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src={RAILS_ASSET_URL('logo_with_name.png')}
        alt='Thatch'
        className='h-6'
      />
      <XIcon className='h-[10px] w-[10px] text-gray-400' aria-hidden='true' />
      <img
        src={carrierPartnership.logo_url}
        alt={carrierPartnership.display_name}
        className='h-[18px] w-auto object-contain'
      />
    </div>
  )
}
